module.exports = __webpack_public_path__ + "img/patient-landing-goal.c2a8cb3e.svg";